import { render, staticRenderFns } from "./AddNewProduct.vue?vue&type=template&id=4717f0f7&scoped=true"
import script from "./AddNewProduct.vue?vue&type=script&lang=js"
export * from "./AddNewProduct.vue?vue&type=script&lang=js"
import style0 from "./AddNewProduct.vue?vue&type=style&index=0&id=4717f0f7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4717f0f7",
  null
  
)

export default component.exports